<template>
    <div v-if="!multiline" class="form-floating" :class="$attrs.class" :style="$attrs.style">
        <input
            :id="resolvedInputId"
            v-model.trim="inputValue"
            :type="type"
            :inputmode="inputmode"
            :class="['form-control', $attrs.class]"
            :style="$attrs.style"
            v-bind="controlAttrs"
            placeholder=" "
            @input="onInput($event.target.value)"
            @blur="$emit('blur', $event)"
        />
        <label v-if="label" :for="resolvedInputId">{{ label }}</label>
    </div>
    <div v-else class="form-floating" :class="$attrs.class" :style="$attrs.style">
        <textarea
            :id="resolvedInputId"
            v-model.trim="inputValue"
            :class="['form-control', $attrs.class]"
            :style="[$attrs.style, { height: '10em' }]"
            v-bind="controlAttrs"
            placeholder=" "
            @input="onInput($event.target.value)"
            @blur="$emit('blur', $event)"
        />
        <label v-if="label" :for="resolvedInputId">{{ label }}</label>
    </div>
</template>

<script>
import { useId } from "vue";

export default {
    components: {},
    inheritAttrs: false,
    props: {
        modelValue: {
            type: [String, Number, Boolean, Object, Array],
            default: ""
        },
        type: {
            type: String,
            default: "text"
        },
        inputmode: {
            type: String,
            default: "text"
        },
        label: {
            type: String,
            default: "Input field"
        },
        validation: {
            type: Function,
            default: (value) => {
                return value;
            }
        },
        multiline: {
            type: Boolean,
            default: false
        }
    },
    emits: ["blur", "input", "update:modelValue"],
    setup() {
        return { generatedInputId: useId() };
    },
    data() {
        return {
            inputValue: this.modelValue
        };
    },
    computed: {
        resolvedInputId() {
            return this.$attrs.id || this.generatedInputId;
        },
        controlAttrs() {
            const attrs = { ...this.$attrs };
            delete attrs.id;
            delete attrs.class;
            delete attrs.style;
            return attrs;
        }
    },
    watch: {
        modelValue(value) {
            if (this.type === "number") this.inputValue = Number(value);
            this.inputValue = value;
        }
    },
    methods: {
        onInput(value) {
            if (this.type === "number") {
                if (value === "") {
                    this.$emit("update:modelValue", "");
                    return;
                }
                if (isNaN(value)) {
                    return;
                }
            }

            const validatedValue = this.validation(value);

            const parsedValue = this.type === "number" ? Number(validatedValue) : validatedValue;
            this.$emit("update:modelValue", parsedValue);
            this.$emit("input", parsedValue);
        }
    }
};
</script>
